import { Link } from "react-router-dom";
import { Card, CardContent, CardHeader } from "../ui/card";
import React from "react";

function NoPermission() {
  return (
    <div>
      <Card>
        <CardHeader>
          <h1>You don&apos;t have permission to View this Page</h1>
        </CardHeader>
        <CardContent>
          <h2>if you think this was a mistake you can contact the admin</h2>
          <p>
            Go back to{" "}
            <Link className="text-accent" to="/dashboard">
              dashboard
            </Link>
          </p>
        </CardContent>
      </Card>
    </div>
  );
}

export default NoPermission;
